<template>
	<div id="text-page">
		<div class="container">
			<h1 class="mb-2 page-title"> {{ 'devoluciones-y-garantias' | static-title }}</h1>
			<static-markdown :content="'devoluciones-y-garantias' | static-content"></static-markdown>
		</div>
	</div>
</template>

<script>
export default {}
</script>
